import { SpaRoutes } from '@spa/constants/routes';
import { useLang } from '@spa/i18n/useLang';
import { NavLink } from 'react-router-dom';

export function LogisticsNoResults() {
  const t = useLang();

  return (
    <div className="flex min-h-20 flex-col items-center justify-center rounded-md border border-biomar-border bg-white px-6 py-12 text-center">
      <h3 className="m-0 text-lg font-semibold text-primary-text">
        {t('logistics.noActiveDeliveries')}
      </h3>

      <p className="m-0 mt-4 max-w-120 text-base text-primary-text/80">
        {t('logistics.noActiveDeliveriesDescription')}
      </p>

      <NavLink
        to={SpaRoutes.COMPANY_ORDERS}
        className="mt-6 inline-flex items-center justify-center rounded-md bg-primary-text 
        no-underline px-6 py-3 text-sm font-semibold text-white! hover:bg-biomar-900"
      >
        {t('logistics.viewOrderHistory')}
      </NavLink>
    </div>
  );
}

export default LogisticsNoResults;
